import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

export default function LoadingContainer({
  loading = false,
  children,
  blurAmount = 'blur-sm', // blur-sm | blur-md | blur-lg
  overlayOpacity = 'bg-black/10',
  className = '',
}) {
  return (
    <div className={cn('relative', className)}>
      {/* Content layer (gets blurred when loading) */}
      <div
        className={cn(
          'transition-all duration-300',
          loading && `pointer-events-none ${blurAmount} opacity-60`
        )}
      >
        {children}
      </div>

      {/* Loader overlay */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center z-20">
          <div
            className={cn('absolute inset-0 backdrop-blur-sm', overlayOpacity)}
          />
          <Loader2 className="z-30 h-10 w-10 animate-spin" />
        </div>
      )}
    </div>
  );
}
